import { colorsPalettes, rgba } from "@similarweb/styles";

export default () => {
    return {
        tooltip: {
            shape: "rect" as const, // "callout"
            style: {
                fontFamily: "Roboto",
                margin: 0,
            },
            backgroundColor: colorsPalettes.carbon[0],
            borderWidth: 0,
            padding: 16,
            borderRadius: 6,
            boxShadow: `0px 0px 8px ${rgba(colorsPalettes.black[0], 0.12)}, 0px 8px 8px ${rgba(
                colorsPalettes.black[0],
                0.24,
            )}`,
        },
    };
};
